export default __webpack_public_path__ + "static/media/lord-krishna.d4b7a17b.jpg";